import { Provider as XooomUiProvider } from '@xooom/ui'
import { ErrorBoundary, I18nLoader } from 'components'
import { GlobalProvider, LoyaltySettingsProvider } from 'context'
import { serviceWorker, store } from 'helpers'
import 'index.css'
import App from 'pages'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom'
import { Provider as Store } from 'react-redux'
import { BillettenProvider } from 'webbook-airways'

ReactDOM.render(
  <ErrorBoundary>
    <XooomUiProvider>
      <BillettenProvider>
        <Store store={store}>
          {/* @ts-ignore */}
          <CookiesProvider>
            <I18nLoader>
              {/* @ts-ignore */}
              <GlobalProvider>
                <LoyaltySettingsProvider>
                  <App />
                </LoyaltySettingsProvider>
              </GlobalProvider>
            </I18nLoader>
          </CookiesProvider>
        </Store>
      </BillettenProvider>
    </XooomUiProvider>
  </ErrorBoundary>,
  document.getElementById('root'),
)

serviceWorker()
